var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/user-profile/get-user-documents.ts
import { SocketAsFetch } from "@leagueplatform/socket-as-fetch";
var GET_USER_DOCUMENTS_MESSAGE_TYPE = "get_user_documents";
var getUserDocuments = (userId) => __async(void 0, null, function* () {
  return SocketAsFetch.fetch(__spreadValues({
    message_type: GET_USER_DOCUMENTS_MESSAGE_TYPE
  }, userId && { info: { user_id: userId } }));
});

// src/user-profile/get-user-payment-credentials.ts
import { SocketAsFetch as SocketAsFetch2 } from "@leagueplatform/socket-as-fetch";
var GET_USER_PAYMENT_CREDENTIALS_MESSAGE_TYPE = "get_user_payment_credentials";
var getUserPaymentCredentials = (userId) => __async(void 0, null, function* () {
  return SocketAsFetch2.fetch(__spreadValues({
    message_type: GET_USER_PAYMENT_CREDENTIALS_MESSAGE_TYPE
  }, userId && { info: { user_id: userId } }));
});

// src/user-profile/get-user-settings.ts
import { SocketAsFetch as SocketAsFetch3 } from "@leagueplatform/socket-as-fetch";
var GET_USER_SETTINGS_MESSAGE_TYPE = "get_user_settings";
var getUserSettings = (userId) => __async(void 0, null, function* () {
  return SocketAsFetch3.fetch(__spreadValues({
    message_type: GET_USER_SETTINGS_MESSAGE_TYPE
  }, userId && { info: { user_id: userId } }));
});

// src/user-profile/get-user-store-credit-balance.ts
import { SocketAsFetch as SocketAsFetch4 } from "@leagueplatform/socket-as-fetch";
var GET_USER_STORE_CREDIT_BALANCE_MESSAGE_TYPE = "get_user_store_credit_balance";
var getUserStoreCreditBalance = (userId) => __async(void 0, null, function* () {
  return SocketAsFetch4.fetch(__spreadValues({
    message_type: GET_USER_STORE_CREDIT_BALANCE_MESSAGE_TYPE
  }, userId && { info: { user_id: userId } }));
});

// src/user-profile/set-user-profile.ts
import { SocketAsFetch as SocketAsFetch5 } from "@leagueplatform/socket-as-fetch";
var SET_USER_PROFILE_MESSAGE_TYPE = "set_user_profile";
var setUserProfile = (userProfile) => __async(void 0, null, function* () {
  return SocketAsFetch5.fetch({
    message_type: SET_USER_PROFILE_MESSAGE_TYPE,
    info: __spreadValues({}, userProfile)
  });
});

// src/user-profile/request-user-phone-change.ts
import { SocketAsFetch as SocketAsFetch6 } from "@leagueplatform/socket-as-fetch";
var REQUEST_PHONE_NUMBER_CHANGE_MESSAGE_TYPE = "request_phone_number_change";
var requestUserPhoneNumberChange = (countryCode, phoneNumber, forceVoiceCall = false) => __async(void 0, null, function* () {
  return SocketAsFetch6.fetch({
    message_type: REQUEST_PHONE_NUMBER_CHANGE_MESSAGE_TYPE,
    info: {
      phone_country_code: countryCode,
      phone_number: phoneNumber,
      voice_call: forceVoiceCall
    }
  });
});

// src/user-profile/get-user-profile.ts
import { SocketAsFetch as SocketAsFetch7 } from "@leagueplatform/socket-as-fetch";
var GET_USER_PROFILE_MESSAGE_TYPE = "get_user_profile";
var getUserProfile = (userId) => SocketAsFetch7.fetch(__spreadValues({
  message_type: GET_USER_PROFILE_MESSAGE_TYPE
}, userId && { info: { user_id: userId } }));

// src/user-profile/get-user-config.ts
import { SocketAsFetch as SocketAsFetch8 } from "@leagueplatform/socket-as-fetch";
var GET_USER_CONFIG_MESSAGE_TYPE = "get_user_config";
var getUserConfig = (userId) => __async(void 0, null, function* () {
  return SocketAsFetch8.fetch(__spreadValues({
    message_type: GET_USER_CONFIG_MESSAGE_TYPE
  }, userId && { info: { user_id: userId } }));
});

// src/user-profile/feature-flags/get-user-feature-flags.ts
import { SocketAsFetch as SocketAsFetch9 } from "@leagueplatform/socket-as-fetch";
var GET_USER_FEATURE_FLAGS_MESSAGE_TYPE = "get_user_feature_flags";
var getUserFeatureFlags = () => __async(void 0, null, function* () {
  return SocketAsFetch9.fetch({
    message_type: GET_USER_FEATURE_FLAGS_MESSAGE_TYPE
  });
});

// src/user-profile/get-auth-method.ts
import { SocketAsFetch as SocketAsFetch10 } from "@leagueplatform/socket-as-fetch";
var GET_AUTH_METHOD_MESSAGE_TYPE = "get_auth_method";
var getAuthMethod = (userId) => __async(void 0, null, function* () {
  return SocketAsFetch10.fetch(__spreadValues({
    message_type: GET_AUTH_METHOD_MESSAGE_TYPE
  }, userId && { info: { user_id: userId } }));
});

// src/group/get-group.ts
import { SocketAsFetch as SocketAsFetch11 } from "@leagueplatform/socket-as-fetch";
var GET_GROUP_MESSAGE_TYPE = "get_group";
var getGroup = (groupId) => __async(void 0, null, function* () {
  return SocketAsFetch11.fetch({
    message_type: GET_GROUP_MESSAGE_TYPE,
    info: {
      group_id: groupId
    }
  });
});

// src/user-profile/feature-flags/use-feature-flag-query.ts
import { useQuery } from "react-query";
function useFeatureFlagQuery(featureFlag) {
  if (!featureFlag)
    throw new Error("Please provide a feature flag name");
  return useQuery([GET_USER_FEATURE_FLAGS_MESSAGE_TYPE], getUserFeatureFlags, {
    staleTime: Infinity,
    // Added to mitigate re-fetching when there are nested uses of the hook in a page
    select: (data) => {
      if (!data.user_flags[featureFlag])
        return false;
      return data.user_flags[featureFlag];
    }
  });
}

// src/group/set-group.ts
import { SocketAsFetch as SocketAsFetch12 } from "@leagueplatform/socket-as-fetch";
var SET_GROUP_MESSAGE_TYPE = "set_group";
var setGroup = ({ groupId, group }) => SocketAsFetch12.fetch({
  message_type: SET_GROUP_MESSAGE_TYPE,
  info: {
    group_id: groupId,
    group
  }
});
export {
  GET_AUTH_METHOD_MESSAGE_TYPE,
  GET_GROUP_MESSAGE_TYPE,
  GET_USER_CONFIG_MESSAGE_TYPE,
  GET_USER_DOCUMENTS_MESSAGE_TYPE,
  GET_USER_FEATURE_FLAGS_MESSAGE_TYPE,
  GET_USER_PAYMENT_CREDENTIALS_MESSAGE_TYPE,
  GET_USER_PROFILE_MESSAGE_TYPE,
  GET_USER_SETTINGS_MESSAGE_TYPE,
  GET_USER_STORE_CREDIT_BALANCE_MESSAGE_TYPE,
  REQUEST_PHONE_NUMBER_CHANGE_MESSAGE_TYPE,
  SET_GROUP_MESSAGE_TYPE,
  SET_USER_PROFILE_MESSAGE_TYPE,
  getAuthMethod,
  getGroup,
  getUserConfig,
  getUserDocuments,
  getUserFeatureFlags,
  getUserPaymentCredentials,
  getUserProfile,
  getUserSettings,
  getUserStoreCreditBalance,
  requestUserPhoneNumberChange,
  setGroup,
  setUserProfile,
  useFeatureFlagQuery
};
//# sourceMappingURL=index.js.map